import { ExchangeError } from '../../../errors.js';
const SERVER = new URL('https://api.simpleswap.io/v3');
const KEY = new Map([
    ['intl', '0c45377c-cd5d-4a33-8059-6e864131cd9d'],
    ['us', 'a602eb91-d8c8-4c8a-8556-83066fa0427c'],
]);
const getSimpleswapOrder = async ({ orderId, apiKey, }, fetchival) => {
    try {
        const response = await fetchival(new URL(`${SERVER}/exchanges/${encodeURIComponent(orderId)}?api_key=${encodeURIComponent(apiKey)}`)).get();
        return response.result;
    }
    catch (error) {
        throw new ExchangeError({ message: JSON.stringify(error) }, { cause: error });
    }
};
const createGetProviderOrder = (geolocation) => async (providerOrder, fetchival) => {
    const apiKey = KEY.get(geolocation);
    if (!apiKey) {
        throw new ExchangeError({ message: 'Missing apiKey for SimpleSwap' });
    }
    const orderInfo = await getSimpleswapOrder({ orderId: providerOrder.id, apiKey }, fetchival);
    return {
        orderId: orderInfo.id,
        depositAddress: orderInfo.addressFrom,
        depositAmount: orderInfo.amountFrom,
        withdrawalAddress: orderInfo.addressTo,
    };
};
const simpleswapConfig = {
    ss: createGetProviderOrder('intl'),
    ssus: createGetProviderOrder('us'),
};
export default simpleswapConfig;
